<div class="bottomsheet-content-container">
    <div class="bottomsheet-header-container">
        <button class="back-btn" *ngIf="showBackButton()" (click)="onBack()">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Group_153"
                data-name="Group 153" width="11.038" height="19.841" viewBox="0 0 11.038 19.841">
                <defs>
                    <clipPath id="clip-path">
                        <rect id="Rectangle_99" data-name="Rectangle 99" width="11.038" height="19.841"
                            fill="#afb4ac" />
                    </clipPath>
                </defs>
                <g id="Group_143" data-name="Group 143" transform="translate(0 0)" clip-path="url(#clip-path)">
                    <path id="Path_338" data-name="Path 338"
                        d="M9.8,19.841a1,1,0,0,0,.707-1.707l-8.1-8.1,8.331-8.331A1,1,0,1,0,9.331.293L.293,9.331a1,1,0,0,0,0,1.414l8.8,8.8a1,1,0,0,0,.707.293"
                        transform="translate(0 0)" fill="#afb4ac" />
                </g>
            </svg>
            <label>Back</label>
        </button>
        <button class="modal-close-btn" (click)="openLink($event)" *ngIf="currentStep === 'SHARE'">Cancel</button>
    </div>
    <div class="bottomsheet-body-container">
        <div *ngIf="currentStep === 'SHARE'" class="share-container">
            <h2>What do You Want to Share?</h2>
            <mat-accordion>
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Personal Information
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="19.841" height="11.038" viewBox="0 0 19.841 11.038" class="arrow-icon">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_99" data-name="Rectangle 99" width="11.038" height="19.841"
                                            fill="#bfc6ba" />
                                    </clipPath>
                                </defs>
                                <g id="Group_145" data-name="Group 145" transform="translate(19.841) rotate(90)">
                                    <g id="Group_143" data-name="Group 143" transform="translate(0 0)"
                                        clip-path="url(#clip-path)">
                                        <path id="Path_338" data-name="Path 338"
                                            d="M1.235,0A1,1,0,0,0,.528,1.707l8.1,8.1L.293,18.134a1,1,0,1,0,1.414,1.414l9.038-9.038a1,1,0,0,0,0-1.414l-8.8-8.8A1,1,0,0,0,1.235,0"
                                            transform="translate(0 0)" fill="#bfc6ba" />
                                    </g>
                                </g>
                            </svg>
                        </mat-panel-title>
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31"
                            *ngIf="completedSections.personal">
                            <g id="Group_169" data-name="Group 169" transform="translate(-372 -706)">
                                <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(372 706)" fill="#fff"
                                    stroke="#652d90" stroke-width="1">
                                    <circle cx="15.5" cy="15.5" r="15.5" stroke="none" />
                                    <circle cx="15.5" cy="15.5" r="15" fill="none" />
                                </g>
                                <path id="Path_339" data-name="Path 339" d="M3952.078,2997.549l4.907,4.907,10.4-10.4"
                                    transform="translate(-3572.229 -2275.729)" fill="none" stroke="#652d90"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </g>
                        </svg> -->
                    </mat-expansion-panel-header>

                    <div class="panel-content">
                        <div class="include-all-container">
                            <mat-checkbox checked>Include All</mat-checkbox>
                            <div class="divider"></div>
                        </div>

                        <mat-radio-group>
                            <mat-radio-button value="name">Name</mat-radio-button>
                            <mat-radio-button value="dob">DOB</mat-radio-button>
                            <mat-radio-button value="contact">Contact info</mat-radio-button>
                            <mat-radio-button value="demographics">Demographics</mat-radio-button>
                        </mat-radio-group>

                        <button matButton="outlined" class="panel-btn" (click)="currentStep = 'RECEIVER'">Go to Next
                            Category</button>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Insurance Information
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="19.841" height="11.038" viewBox="0 0 19.841 11.038" class="arrow-icon">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_99" data-name="Rectangle 99" width="11.038" height="19.841"
                                            fill="#bfc6ba" />
                                    </clipPath>
                                </defs>
                                <g id="Group_145" data-name="Group 145" transform="translate(19.841) rotate(90)">
                                    <g id="Group_143" data-name="Group 143" transform="translate(0 0)"
                                        clip-path="url(#clip-path)">
                                        <path id="Path_338" data-name="Path 338"
                                            d="M1.235,0A1,1,0,0,0,.528,1.707l8.1,8.1L.293,18.134a1,1,0,1,0,1.414,1.414l9.038-9.038a1,1,0,0,0,0-1.414l-8.8-8.8A1,1,0,0,0,1.235,0"
                                            transform="translate(0 0)" fill="#bfc6ba" />
                                    </g>
                                </g>
                            </svg>
                        </mat-panel-title>
                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31"
                            *ngIf="completedSections.insurance">
                            <g id="Group_169" data-name="Group 169" transform="translate(-372 -706)">
                                <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(372 706)" fill="#fff"
                                    stroke="#652d90" stroke-width="1">
                                    <circle cx="15.5" cy="15.5" r="15.5" stroke="none" />
                                    <circle cx="15.5" cy="15.5" r="15" fill="none" />
                                </g>
                                <path id="Path_339" data-name="Path 339" d="M3952.078,2997.549l4.907,4.907,10.4-10.4"
                                    transform="translate(-3572.229 -2275.729)" fill="none" stroke="#652d90"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </g>
                        </svg>
                    </mat-expansion-panel-header>

                    <div class="panel-content">
                        <div class="include-all-container">
                            <mat-checkbox checked>Include All</mat-checkbox>
                            <div class="divider"></div>
                        </div>

                        <mat-radio-group>
                            <mat-radio-button value="primaryInsurance">Primary Insurance</mat-radio-button>
                            <mat-radio-button value="medicareSupplemet">Medicare Supplemet</mat-radio-button>
                            <mat-radio-button value="hsa">HSA</mat-radio-button>
                            <mat-radio-button value="vision">Vision</mat-radio-button>
                            <mat-radio-button value="dental">Dental</mat-radio-button>
                        </mat-radio-group>

                        <button matButton="outlined" (click)="saveSelection('insurance')" class="panel-btn">Go to Next
                            Category</button>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Reason for Visit / Conditions
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="19.841" height="11.038" viewBox="0 0 19.841 11.038" class="arrow-icon">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_99" data-name="Rectangle 99" width="11.038" height="19.841"
                                            fill="#bfc6ba" />
                                    </clipPath>
                                </defs>
                                <g id="Group_145" data-name="Group 145" transform="translate(19.841) rotate(90)">
                                    <g id="Group_143" data-name="Group 143" transform="translate(0 0)"
                                        clip-path="url(#clip-path)">
                                        <path id="Path_338" data-name="Path 338"
                                            d="M1.235,0A1,1,0,0,0,.528,1.707l8.1,8.1L.293,18.134a1,1,0,1,0,1.414,1.414l9.038-9.038a1,1,0,0,0,0-1.414l-8.8-8.8A1,1,0,0,0,1.235,0"
                                            transform="translate(0 0)" fill="#bfc6ba" />
                                    </g>
                                </g>
                            </svg>
                        </mat-panel-title>
                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31"
                            *ngIf="completedSections.reason">
                            <g id="Group_169" data-name="Group 169" transform="translate(-372 -706)">
                                <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(372 706)" fill="#fff"
                                    stroke="#652d90" stroke-width="1">
                                    <circle cx="15.5" cy="15.5" r="15.5" stroke="none" />
                                    <circle cx="15.5" cy="15.5" r="15" fill="none" />
                                </g>
                                <path id="Path_339" data-name="Path 339" d="M3952.078,2997.549l4.907,4.907,10.4-10.4"
                                    transform="translate(-3572.229 -2275.729)" fill="none" stroke="#652d90"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </g>
                        </svg>
                    </mat-expansion-panel-header>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Medications & Prescriptions
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="19.841" height="11.038" viewBox="0 0 19.841 11.038" class="arrow-icon">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_99" data-name="Rectangle 99" width="11.038" height="19.841"
                                            fill="#bfc6ba" />
                                    </clipPath>
                                </defs>
                                <g id="Group_145" data-name="Group 145" transform="translate(19.841) rotate(90)">
                                    <g id="Group_143" data-name="Group 143" transform="translate(0 0)"
                                        clip-path="url(#clip-path)">
                                        <path id="Path_338" data-name="Path 338"
                                            d="M1.235,0A1,1,0,0,0,.528,1.707l8.1,8.1L.293,18.134a1,1,0,1,0,1.414,1.414l9.038-9.038a1,1,0,0,0,0-1.414l-8.8-8.8A1,1,0,0,0,1.235,0"
                                            transform="translate(0 0)" fill="#bfc6ba" />
                                    </g>
                                </g>
                            </svg>
                        </mat-panel-title>
                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31"
                            *ngIf="completedSections.meds">
                            <g id="Group_169" data-name="Group 169" transform="translate(-372 -706)">
                                <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(372 706)" fill="#fff"
                                    stroke="#652d90" stroke-width="1">
                                    <circle cx="15.5" cy="15.5" r="15.5" stroke="none" />
                                    <circle cx="15.5" cy="15.5" r="15" fill="none" />
                                </g>
                                <path id="Path_339" data-name="Path 339" d="M3952.078,2997.549l4.907,4.907,10.4-10.4"
                                    transform="translate(-3572.229 -2275.729)" fill="none" stroke="#652d90"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </g>
                        </svg>
                    </mat-expansion-panel-header>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Imaging & Test Results
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="19.841" height="11.038" viewBox="0 0 19.841 11.038" class="arrow-icon">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_99" data-name="Rectangle 99" width="11.038" height="19.841"
                                            fill="#bfc6ba" />
                                    </clipPath>
                                </defs>
                                <g id="Group_145" data-name="Group 145" transform="translate(19.841) rotate(90)">
                                    <g id="Group_143" data-name="Group 143" transform="translate(0 0)"
                                        clip-path="url(#clip-path)">
                                        <path id="Path_338" data-name="Path 338"
                                            d="M1.235,0A1,1,0,0,0,.528,1.707l8.1,8.1L.293,18.134a1,1,0,1,0,1.414,1.414l9.038-9.038a1,1,0,0,0,0-1.414l-8.8-8.8A1,1,0,0,0,1.235,0"
                                            transform="translate(0 0)" fill="#bfc6ba" />
                                    </g>
                                </g>
                            </svg>
                        </mat-panel-title>
                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31"
                            *ngIf="completedSections.imaging">
                            <g id="Group_169" data-name="Group 169" transform="translate(-372 -706)">
                                <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(372 706)" fill="#fff"
                                    stroke="#652d90" stroke-width="1">
                                    <circle cx="15.5" cy="15.5" r="15.5" stroke="none" />
                                    <circle cx="15.5" cy="15.5" r="15" fill="none" />
                                </g>
                                <path id="Path_339" data-name="Path 339" d="M3952.078,2997.549l4.907,4.907,10.4-10.4"
                                    transform="translate(-3572.229 -2275.729)" fill="none" stroke="#652d90"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </g>
                        </svg>
                    </mat-expansion-panel-header>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div *ngIf="currentStep === 'RECEIVER'" class="receiver-container">
            <h2>Who Should Receive This?</h2>
            <div class="btn-container">
                <button matButton="outlined">An Office I Am Visiting</button>
                <button matButton="outlined">My Doctor</button>
                <button matButton="outlined">Someone I've Shared With Before</button>
                <button matButton="outlined">My Insurance Company</button>
                <button matButton="outlined" (click)="currentStep = 'NEW_RECIPIENT'" class="someone-now-btn">Someone
                    New</button>
            </div>
            <div class="search-container">
                <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19.243"
                        height="19.565" viewBox="0 0 19.243 19.565">
                        <defs>
                            <clipPath id="clip-path">
                                <rect id="Rectangle_68" data-name="Rectangle 68" width="19.243" height="19.565"
                                    transform="translate(0 0)" fill="#6d6e71" />
                            </clipPath>
                        </defs>
                        <g id="Group_89" data-name="Group 89" transform="translate(0 0)">
                            <g id="Group_88" data-name="Group 88" clip-path="url(#clip-path)">
                                <path id="Path_302" data-name="Path 302"
                                    d="M18.921,17.688,13.5,12.271a7.583,7.583,0,1,0-1.6,1.509l5.463,5.463a1.1,1.1,0,1,0,1.556-1.555M1.5,7.573a6.074,6.074,0,1,1,6.074,6.074A6.08,6.08,0,0,1,1.5,7.573"
                                    fill="#6d6e71" />
                            </g>
                        </g>
                    </svg>
                </span>
                <input type="text" placeholder="Search by name, office, or email" />
            </div>
        </div>
        <div *ngIf="currentStep === 'NEW_RECIPIENT'" class="new-recipient-container">
            <h2 class="small-title">New Recipient</h2>
            <form class="wizard__form">
                <section class="panel">
                    <div class="field">
                        <label>Organization</label>
                        <input type="text" value="Excel Orthopedics" />
                    </div>
                    <div class="field">
                        <label>Attention</label>
                        <input type="text" value="Dr. Lenarz" />
                    </div>
                    <div class="field">
                        <label>Email</label>
                        <input type="email" value="careteam@excel-orthopedics.com" />
                        <span class="hint-text">
                            This recipient will receive a secure access link.
                        </span>
                    </div>
                    <div class="field">
                        <label>Phone</label>
                        <input type="text" placeholder="(Optional)" />
                    </div>
                </section>
            </form>
            <button matButton="outlined" class="continue-recipient-btn" (click)="currentStep = 'READY'">Continue with
                Recipient</button>
        </div>
        <div *ngIf="currentStep === 'READY'" class="ready-container">
            <h2>Ready to send?</h2>
            <div class="content-container">
                <p class="small-bold-text">You're about to securely share:</p>
                <ul>
                    <li>Personal information</li>
                    <li>Insurance details</li>
                    <li>Recent imaging</li>
                </ul>
                <p class="small-bold-text">With:</p>
                <p class="small-bold-text">Excel Orthopedics – Front Desk</p>
                <input type="text" placeholder="Add a note (optional)" />
                <div class="bottom-content">
                    <div class="btn-with-text-container">
                        <button matButton="filled" (click)="sendSecurely()">Send Securely</button>
                        <p>You stay in control of what's shared.</p>
                    </div>
                    <button matButton="outlined" (click)="openConfirmationDialog()" class="cancel-btn">Cancel</button>
                </div>
            </div>
        </div>
    </div>
    <div class="bottomsheet-footer-container">
        <app-bottom-nav [onNavigate]="closeBottomSheet.bind(this)"></app-bottom-nav>
    </div>
</div>